import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ProductFulfillmentAuditPageCache } from '../models/interfaces/PageCache';

const GET_FULLFILLAUDIT_PAGE_CACHE = gql`
  query GetAdvertisersPageCache {
    fulfillmentAuditPageCache @client {
      sortOptions {
        advertiser_name
        campaign_name
        quantity
        tgrams_id
        owner
        status
        allocatedPoints
        valid
        opportunity_id
        item_id
      }
      activeSort {
        sortKey
        sortDirection
      }
    }
  }
`;

interface ProductFulfillmentAuditCacheContainerProps {
  children: (props: any) => any;
}

export interface ProductFulfillmentAuditCacheQueryResults {
  fulfillmentAuditPageCache: ProductFulfillmentAuditPageCache;
  // updateCache: (data: any) => void;
  // updateProductFulfillmentPage: (from: number, size: number) => void;
}
//class AdvertisersPageCacheQuery extends Query<AdvertisersPageCacheQueryResults> {}

const ProductFulfillmentAuditCacheContainer: React.FunctionComponent<
  ProductFulfillmentAuditCacheContainerProps
> = ({ children }) => {
  return (
    <Query<ProductFulfillmentAuditCacheQueryResults> query={GET_FULLFILLAUDIT_PAGE_CACHE}>
      {({
        data: { fulfillmentAuditPageCache } = {
          fulfillmentAuditPageCache: {}
        },
        loading,
        error,
        client
      }) => {
        return children({
          loading,
          error,
          fulfillmentAuditPageCache,
          updateCache: async (data: any) => {
            await client.writeData({ data });
          },
          client
        });
      }}
    </Query>
  );
};

export default ProductFulfillmentAuditCacheContainer;
